import { Input } from "antd";
import { useId } from "react";

import s from "./CommentField.module.css";

interface CommentFieldProps {
  label: string;
  placeholder: string;
  value: string;
  onChange: (value: string) => void;
  optionalSuffix?: string;
  maxLength?: number;
  disabled?: boolean;
}

export const CommentField = ({
  label,
  placeholder,
  value,
  onChange,
  optionalSuffix,
  maxLength = 1000,
  disabled = false,
}: CommentFieldProps) => {
  const inputId = useId();

  return (
    <div className={s.root}>
      <label className={s.label} htmlFor={inputId}>
        {label}
        {optionalSuffix && <span className={s.optional}>{optionalSuffix}</span>}
      </label>
      <Input.TextArea
        id={inputId}
        className={s.textarea}
        data-testid="feedback-comment"
        value={value}
        onChange={event => onChange(event.target.value)}
        placeholder={placeholder}
        maxLength={maxLength}
        disabled={disabled}
        rows={3}
      />
    </div>
  );
};
